import { FilterButton } from '@/components/ui/filter-button';
import { Input } from '@/components/ui/input';
import { MultiSelect } from '@/components/ui/multi-select';
import { Select, SelectContent, SelectItemWithRadio, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useResourceHubFilters } from '../../hooks/useResourceHubFilters';

export const ResourceHubFilters = () => {
  const {
    localSearchQuery,
    setLocalSearchQuery,
    wrapperRef,
    buttonsContainerRef,
    filteredRootCategories,
    categorySelectValue,
    handleCategorySelect,
    subcategoryOptions,
    selectedSubcategoryIds,
    handleSubcategoryChange,
    setCategoryRef,
    selectedCategoryIds,
    toggleCategory,
    hasActiveFilters,
    resetFilters,
    containerWidth,
    buttonsOffsetLeft,
    generateLineWithChevrons,
    visibleSubcategories,
    toggleSubcategory,
    hasSelectedCategories,
  } = useResourceHubFilters();

  return (
    <div className="mb-[16px]">
      <div className="mb-[16px]">
        <Input
          theme="search"
          placeholder="Search"
          value={localSearchQuery}
          onChange={(e) => setLocalSearchQuery(e.target.value)}
          aria-label="Search"
          className="w-full"
        />
      </div>

      <div ref={wrapperRef} className="flex flex-col items-center">
        <div className="flex w-full flex-wrap items-center gap-2 md:justify-center">
          <span className="hidden font-haffer text-sh-14-20 font-medium text-gray-700 md:mr-2 md:inline">
            Filter results
          </span>

          <div className="flex w-full flex-row flex-wrap items-center gap-2 md:contents">
            <div className="flex w-full flex-col gap-3 md:hidden">
              <div className="flex w-full min-w-0 items-center gap-2">
                <div className="min-w-0 flex-1">
                  <Select
                    key={categorySelectValue || 'none'}
                    value={categorySelectValue || undefined}
                    onValueChange={handleCategorySelect}>
                    <SelectTrigger className="w-full">
                      <SelectValue placeholder="Choose filters" />
                    </SelectTrigger>
                    <SelectContent>
                      {filteredRootCategories.map((category) => (
                        <SelectItemWithRadio
                          key={category.documentId}
                          value={category.documentId}
                          indicatorColor={category.color ?? undefined}>
                          {category.category}
                        </SelectItemWithRadio>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <button
                  type="button"
                  onClick={resetFilters}
                  className="shrink-0 font-haffer text-sh-14-20 font-bold text-black-100 hover:underline"
                  aria-label="Clear all filters">
                  Clear
                </button>
              </div>
              {hasSelectedCategories && subcategoryOptions.length > 0 && (
                <div className="w-full">
                  <MultiSelect
                    options={subcategoryOptions}
                    value={selectedSubcategoryIds}
                    onValueChange={handleSubcategoryChange}
                    placeholder="Subcategories"
                    showSelectAll={false}
                  />
                </div>
              )}
            </div>

            <div ref={buttonsContainerRef} className="hidden flex-wrap items-center justify-center gap-2 md:flex">
              {filteredRootCategories.map((category) => (
                <FilterButton
                  key={category.documentId}
                  ref={setCategoryRef(category.documentId)}
                  isSelected={selectedCategoryIds.includes(category.documentId)}
                  hasBorder
                  showColorIndicator
                  color={category.color}
                  onClick={() => toggleCategory(category.documentId)}>
                  {category.category}
                </FilterButton>
              ))}
            </div>

            {hasActiveFilters && (
              <button
                type="button"
                onClick={resetFilters}
                className="hidden font-haffer text-sh-14-20 font-bold text-black-100 hover:underline md:ml-2 md:inline-block"
                aria-label="Clear all filters">
                Clear
              </button>
            )}
          </div>
        </div>

        {hasSelectedCategories && visibleSubcategories.length > 0 && (
          <>
            <div
              className="my-3 hidden md:block"
              style={{
                width: containerWidth > 0 ? containerWidth : '100%',
                marginLeft: buttonsOffsetLeft > 0 ? buttonsOffsetLeft : undefined,
                alignSelf: 'flex-start',
              }}>
              <svg width={containerWidth} height="10" className="block overflow-visible">
                <path d={generateLineWithChevrons} fill="none" stroke="#d1d5db" strokeWidth="1" />
              </svg>
            </div>
            <div className="hidden flex-wrap items-center justify-center gap-2 md:flex">
              {visibleSubcategories.map(({ subcategory, parentColor }) => (
                <FilterButton
                  key={subcategory.documentId}
                  isSelected={selectedSubcategoryIds.includes(subcategory.documentId)}
                  hasBorder
                  showColorIndicator
                  color={subcategory.color ?? parentColor}
                  onClick={() => toggleSubcategory(subcategory.documentId)}>
                  {subcategory.category}
                </FilterButton>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
